import { ExternalObjectConf } from '@bageltechnologies/bagel-common';

type KeyedExternalObject = Pick<ExternalObjectConf, 'originObjectKey' | 'originObject' | 'name'>;

export const resolveOriginObjectKey = (
  externalObject: Partial<KeyedExternalObject> | null | undefined,
): string =>
  externalObject?.originObjectKey || externalObject?.originObject || externalObject?.name || '';
